<template>
  <div>
    <BaseLineChartCard
      :labelsArray="getLabelsArray(usersStats.newUsersCountPerDuration)"
      chartLabel="مستخدم جديد"
      :dataArray="getDataArray(usersStats.newUsersCountPerDuration)"
    >
      <template v-slot:title> عدد المستخدمين المنضمين  </template>
      <template v-slot:durationSelection>
        <BaseSelect
          :items="durations"
          v-model="usersStats.newUsersCountDuration"
          chips
          dense
          placeholder="المدة الزمنية"
          value="value"
        >
          <template v-slot:item="{ item }"> خلال {{ item.label }} </template>
          <template v-slot:selection="{ item }">
            خلال {{ item.label }}
          </template>
        </BaseSelect>
      </template>
    </BaseLineChartCard>
  </div>
</template>

<script>
import { useStatisticsStore } from "@/modules/home/store/StatisticsStore";
import { mapActions, mapWritableState } from "pinia";
import BaseLineChartCard from "../../base_statistics_cards/BaseLineChartCard.vue";
import StatisticsDurations from "../../statics/StatisticsDurations";

export default {
  components: { BaseLineChartCard },
  methods: {
    ...mapActions(useStatisticsStore, [
      "getLabelsArray",
      "getDataArray",
      "fetchUsersStatistics",
    ]),
  },
  watch: {
    "usersStats.newUsersCountDuration": function () {
      this.fetchUsersStatistics()
        .then()
        .catch((err) => console.error(err));
    },
  },
  computed: {
    ...mapWritableState(useStatisticsStore, ["usersStats"]),
  },
  data() {
    return {
      durations: StatisticsDurations,
    };
  },
};
</script>
